import React from 'react';
import { Stack, Breakpoint, Text } from '@moda/om';
import { useLocation, matchPath } from 'react-router-dom';
import { AccountNavMobile } from '../../../components/AccountNav';
import { ACCOUNT_ROUTES } from '../../../routers';
import { PageMeta } from '../../../components/PageMeta';

import './AccountPageContent.scss';

export type Props = {
  title?: string;
  description?: React.ReactNode;
};

export const AccountPageContent: React.FC<Props> = ({ title, description, children }) => {
  const { pathname } = useLocation();

  const currentRoute = ACCOUNT_ROUTES.find(route => matchPath(pathname, route));

  return (
    <>
      <PageMeta title={`Account Center${currentRoute?.label ? ` - ${currentRoute.label}` : ''}`} />

      <Stack space={5}>
        <Breakpoint lt="md">
          <Stack space={3}>
            <Text family="serif" treatment="h5">
              My Account
            </Text>

            <Stack direction="horizontal" justifyContent="space-between" space={2}>
              {currentRoute && (
                <Text family="serif" treatment="h4">
                  {currentRoute.label}
                </Text>
              )}
            </Stack>

            <AccountNavMobile />

            <Stack alignItems="center" justifyContent="center" space={0}>
              {description}
            </Stack>
          </Stack>
        </Breakpoint>

        <Breakpoint gt="md">
          <Stack
            alignItems="baseline"
            direction="horizontal"
            justifyContent="space-between"
            space={2}
          >
            {title && <h1 className="AccountPageContent__title">{title}</h1>}

            {description}
          </Stack>
        </Breakpoint>

        {children}
      </Stack>
    </>
  );
};
